
import { useState } from 'react';
import { usePets } from '../hooks/usePets';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import PetListItem from '@/components/PetListItem';
import AddPetModal from '@/components/AddPetModal';
import { useTranslation } from 'react-i18next';

const MyPets = () => {
  const [isAddPetModalOpen, setIsAddPetModalOpen] = useState(false);
  const { pets, isLoading, error } = usePets();
  const { t } = useTranslation();

  console.log('MyPets - Component state:', {
    isLoading,
    error: error?.message || null,
    petsCount: pets?.length || 0,
    pets: pets
  });

  if (error) {
    console.error('MyPets - Error state:', error);
    return (
      <div className="p-4 flex flex-col min-h-[60vh]">
        <div className="flex-1 flex items-center justify-center">
          <div className="text-center">
            <p className="text-red-500 mb-2">{t('myPets.errorLoading')}</p>
            <Button variant="default" onClick={() => window.location.reload()}>
              {t('common.tryAgain')}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  if (pets && pets.length > 0) {
    console.log('MyPets - Rendering pets:', pets);
    pets.forEach((pet) => {
      console.log('MyPets - Rendering individual pet:', pet);
    });
  }

  return (
    <div className="p-4 pb-24">
      <div className="flex justify-between items-center mb-6">
        <Button
          onClick={() => setIsAddPetModalOpen(true)}
          className="bg-pet-purple hover:bg-pet-purple/90 ml-auto"
        >
          <Plus className="h-5 w-5 mr-1" /> {t('myPets.addPet')}
        </Button>
      </div>

      <div className="max-w-md mx-auto">
        {isLoading ? (
          // Loading skeletons
          Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="mb-4 flex items-center">
              <Skeleton className="h-16 w-16 rounded-full" />
              <div className="ml-4">
                <Skeleton className="h-4 w-24 mb-2" />
                <Skeleton className="h-3 w-32" />
              </div>
            </div>
          ))
        ) : pets && pets.length > 0 ? (
          <div className="grid grid-cols-1 gap-4">
            {pets.map((pet) => (
              <PetListItem key={pet.id} pet={pet} />
            ))}
          </div>
        ) : (
          <div className="text-center py-10 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
            <p className="text-gray-500 mb-4">{t('myPets.noPetsYet')}</p>
            <Button
              onClick={() => setIsAddPetModalOpen(true)}
              className="bg-pet-purple hover:bg-pet-purple/90"
            >
              <Plus className="h-5 w-5 mr-1" /> {t('myPets.addFirstPet')}
            </Button>
          </div>
        )}
      </div>

      <AddPetModal
        isOpen={isAddPetModalOpen}
        onClose={() => setIsAddPetModalOpen(false)}
      />
    </div>
  );
};

export default MyPets;
